import { useEffect, useState } from "react";

// Debounces a loading
const useDelayedLoading = (loading: boolean, minDelay = 300, minVisible = 500) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(loading), loading ? minDelay : minVisible);

    return () => clearTimeout(timer);
  }, [loading, minDelay, minVisible]);

  return visible;
};

export default useDelayedLoading;
